<template>
  <v-row dense>
    <v-col cols="12" sm="6">
      <v-text-field
        filled
        class="no-before"
        dense
        hide-details="auto"
        :value="userName"
        :error="!isValid"
        label="Nom"
        @change="e => $emit('update:userName', e)"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        filled
        class="no-before"
        dense
        hide-details="auto"
        :value="comment"
        label="Commentaire"
        @change="e => $emit('update:comment', e)"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TillBaseInfo",
  props: {
    userName: {
      type: String,
      required: true
    },
    comment: {
      type: String,
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isValid() {
      return this.userName !== null && this.userName !== "";
    }
  },
  watch: {
    userName() {
      this.$emit("update:valid", this.isValid);
    }
  }
};
</script>

<style scoped></style>
